export default __webpack_public_path__ + "static/media/bannerOW.61201428.webp";